import { lazy } from "react";

import Loadable from "../components/Loadable";
import MainLayout from "../layout/MainLayout";
import CostView from "../pages/dashboard/CostView/CostView";
import CustomerOfferView from "../pages/dashboard/CustomerOfferView/CustomerOfferView";
import FreightOfferView from "../pages/dashboard/FreightOfferView/FreightOfferView";
import CustomerOrderView from "../pages/dashboard/CustomerOrder/CustomerOrder";
import CustomerView from "../pages/dashboard/CustomerView/CustomerView";
import InventoryView from "../pages/dashboard/InventoryView/InventoryView";
import WarehouseView from "../pages/dashboard/WarehouseView/WarehouseView";
import ItemView from "../pages/dashboard/ItemView/ItemView";
import OfferView from "../pages/dashboard/OfferView/OfferView";
import PurchaseOrderView from "../pages/dashboard/PurchaseOrderView/PurchaseOrderView";
import SalesOrderView from "../pages/dashboard/SalesOrderView/SalesOrderView";
import SampleView from "../pages/dashboard/SampleView/SampleView";
import ShippingInstructionView from "../pages/dashboard/ShippingInstructionView/ShippingInstructionView";
import ShippingInstructionCostingView from "../pages/dashboard/ShippingInstructionCostingView/ShippingInstructionCostingView";
import ShipmentRequestView from "../pages/dashboard/ShipmentRequestView/ShipmentRequestView";
import TradeView from "../pages/dashboard/TradeView/TradeView";
import TicketView from "../pages/dashboard/TicketView/TicketView";
import VendorOfferView from "../pages/dashboard/VendorOfferView/VendorOfferView";
import VendorOrderView from "../pages/dashboard/VendorOrderView/VendorOrderView";
import VendorView from "../pages/dashboard/VendorView/VendorView";
import AddressView from "../pages/dashboard/AddressView/AddressView";
import ConsigneeView from "../pages/dashboard/ConsigneeView/ConsigneeView";
import WarehouseInventoryView from "../pages/dashboard/WarehouseInventoryView/WarehouseInventoryView";
import StoragePrice from "../pages/dashboard/StoragePriceView/StoragePriceElements";
import WorkLogView from "../pages/dashboard/WorkLogView/WorkLogView";
import AuditLogView from "../pages/dashboard/AuditLogView/AuditLogView";
import ReservedVendorOrderView from "../pages/dashboard/ReservedVendorOrderView/ReservedVendorOrderView";
import ReservedCustomerOrderView from "../pages/dashboard/ReservedCustomerOrderView/ReservedCustomerOrderView";
import BlendView from "../pages/dashboard/BlendView/BlendView";
import BatchView from "../pages/dashboard/BatchView/BatchView";
import BatchCostOverview from "../pages/dashboard/BatchView/BatchCostOverview";
import MenuItemView from "../pages/dashboard/MenuItemView/MenuItemView";
import BirthdayView from "../pages/dashboard/BirthdayView/BirthdayView";
import TravelCalendarView from "../pages/dashboard/TravelCalendarView/TravelCalendarView";
import ClaimsReportView from "../pages/dashboard/ClaimsReportView/ClaimsReportView";
import NicotineSugarReportView from "../pages/dashboard/ShipmentRequestView/NicotineSugarReportView";
import FxRateReportView from "../pages/dashboard/FxRateReportView/FxRateReportView";
import StakeholderAccountView from "../pages/dashboard/StakeholderAccountView/StakeholderAccountView";
import InvoiceView from "../pages/dashboard/InvoiceView/InvoiceView";
import VatAnalysisView from "../pages/dashboard/VatAnalysisView/VatAnalysisView";
import ShipmentStatusReportView from "../pages/dashboard/ShipmentStatusReportView/ShipmentStatusReportView";
import StakeholderMapView from "../pages/dashboard/StakeholderMapView/StakeholderMapView";
import AdminCostRateView from "../pages/dashboard/AdminCostRateView/AdminCostRateView";

const DashboardDefault = Loadable(lazy(() => import("../pages/dashboard")));

const MainRoutes = {
  path: "/",
  element: <MainLayout />,
  children: [
    {
      path: "dashboard",
      children: [
        {
          path: "default",
          element: <DashboardDefault />,
        },
      ],
    },
    { path: "item-view", element: <ItemView /> },
    { path: "sample-view", element: <SampleView /> },
    { path: "vendor-offer-view", element: <VendorOfferView /> },
    { path: "reserved-purchase-order-view", element: <ReservedVendorOrderView /> },
    { path: "purchase-order-view", element: <VendorOrderView /> },
    { path: "reserved-sales-order", element: <ReservedCustomerOrderView /> },
    { path: "sales-order", element: <CustomerOrderView /> },
    {
      path: "customer-offer-view",
      children: [{ index: true, element: <CustomerOfferView /> }],
    },
    {
      path: "freight-offer-view",
      children: [{ index: true, element: <FreightOfferView /> }],
    },
    { path: "trade-view", element: <TradeView /> },
    { path: "storage-price", element: <StoragePrice /> },
    { path: "warehouse-view", element: <WarehouseView /> },
    { path: "warehouse-inventory-view", element: <WarehouseInventoryView /> },
    { path: "inventory-view", element: <InventoryView /> },
    { path: "vendor-view", element: <VendorView /> },
    { path: "customer-view", element: <CustomerView /> },
    { path: "consignee-view", element: <ConsigneeView /> },
    { path: "stakeholder-address-view", element: <AddressView /> },
    { path: "cost-view", element: <CostView /> },
    { path: "shipment-request-view", element: <ShipmentRequestView /> },
    //{ path: "admin-cost-view", element: <AdminCostView /> },
    { path: "purchase-order-view", element: <PurchaseOrderView /> },
    { path: "sales-order-view", element: <SalesOrderView /> },
    { path: "shipping-instruction-view", element: <ShippingInstructionView /> },
    { path: "shipping-instruction-costing-view", element: <ShippingInstructionCostingView /> },
    { path: "offer-view", element: <OfferView /> },
    { path: "ticket-view", element: <TicketView /> },
    { path: "work-log-view", element: <WorkLogView /> },
    { path: "audit-log-view", element: <AuditLogView /> },
    { path: "blend-view", element: <BlendView/> },
    { path: "batch-view", element: <BatchView/> },
    { path: "batch-cost-overview", element: <BatchCostOverview/> },
    { path: "menu-item-view", element: <MenuItemView/> },
    { path: "birthday-view", element: <BirthdayView/> },
    { path: "travel-calendar-view", element: <TravelCalendarView/> },
    { path: "claims-report-view", element: <ClaimsReportView/> },
    { path: "nicotine-sugar-report-view", element: <NicotineSugarReportView/> },
    { path: "fx-rate-report-view", element: <FxRateReportView/> },
    { path: "stakeholder-account-view", element: <StakeholderAccountView/> },
    { path: "invoice-view", element: <InvoiceView/> },
    { path: "vat-analysis-view", element: <VatAnalysisView/> },
    { path: "shipment-status-report-view", element: <ShipmentStatusReportView /> },
    { path: "stakeholder-report-view", element: <StakeholderMapView /> },
    { path: "admin-cost-rate-view", element: <AdminCostRateView /> },
  ],
};

export default MainRoutes;
